export function shouldDoSetup(account) {
    if ("zoomAccount" in account === false)
        return true;
    if (account.zoomAccount.deployments.length == 0 && !account.confirmedAt)
        return true;
    if ("contact" in account === false)
        return true;
    return false;
}
